module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /~/react-bootstrap-validation/~/babel-runtime/core-js/object/create.js
// module id = 1502
// module chunks = 0